import type { WidgetFeatures } from "../../customization/lib/config-schema";

type StakingConfig = WidgetFeatures["staking"];
type StakingAsset = "eth" | "sol";

function isEthereumEnabled(stakingConfig: StakingConfig): boolean {
  return stakingConfig.ethereum?.enabled !== false;
}

function isSolanaEnabled(stakingConfig: StakingConfig): boolean {
  return stakingConfig.solana?.enabled !== false;
}

function resolveFromFlags(
  requestedAsset: string | null | undefined,
  ethereumEnabled: boolean,
  solanaEnabled: boolean,
): StakingAsset | null {
  if (requestedAsset === "eth") {
    if (ethereumEnabled) return "eth";
    if (solanaEnabled) return "sol";
    return null;
  }

  if (requestedAsset === "sol") {
    if (solanaEnabled) return "sol";
    if (ethereumEnabled) return "eth";
    return null;
  }

  return null;
}

/**
 * Picks the staking asset to navigate to for tab/default entrypoints.
 * Prefers ETH unless wallet is Solana and SOL is enabled.
 */
export function getPreferredStakingAsset(
  stakingConfig: StakingConfig,
  isSolanaWallet: boolean,
): StakingAsset | null {
  const ethEnabled = isEthereumEnabled(stakingConfig);
  const solEnabled = isSolanaEnabled(stakingConfig);

  if (isSolanaWallet && solEnabled) return "sol";
  if (ethEnabled) return "eth";
  if (solEnabled) return "sol";
  return null;
}

export function resolveStakingAssetFromEnabled(
  requestedAsset: string | null | undefined,
  ethereumEnabled: boolean,
  solanaEnabled: boolean,
): StakingAsset | null {
  return resolveFromFlags(requestedAsset, ethereumEnabled, solanaEnabled);
}
